module.exports = __webpack_public_path__ + "img/loginback.6deb9ce5.png";